/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Laden"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var nlNL = Object.assign(TranslationProviderComponent, {
  translations
});

export { nlNL as n };
//# sourceMappingURL=nl-NL-DV7t9k8a.js.map
